// Dependencies
import React from 'react'
import { NavLink } from "react-router";

const ButtonOutline = (props) => {
  return (
    <NavLink to={props.navigationURL} className='border border-[#06BD60] text-[#06BD60] px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer'>
        {props.buttonText}
    </NavLink>
  )
}

export default ButtonOutline